<template>
<section class="person-grid px-4 py-8">
    <div class="max-w-4xl mx-auto">
        <h2 v-if="headline" v-html="headline" class="font-headline text-3xl my-8 text-primary-700 uppercase leading-tight text-center"></h2>
        <SmoothLoader class="grid">
            <button v-for="(person, i) in people" :id="person.slug" class="person-wrapper flex flex-wrap justify-center relative" @click="openPerson(i)">
                
                <div class="headshot w-full flex justify-center rounded-full overflow-hidden" :class="{'bg-primary-700 bg-opacity-20': !person.photo}">
                    <img v-if="person.photo" :src="person.photo.src" class="">
                </div>

                <div class="p-4 text-center">
                    <span class="name block font-headline font-bold text-primary-600 transition-colors" v-html="person.name"></span>
                    <span v-if="person.job_title" class="title block text-sm font-headline font-bold uppercase text-primary-800 transition-colors mt-2" v-html="person.job_title"></span>
                    <span class="subtitle transition-colors block text-xs mt-2 text-primary-700 font-headline font-bold" v-if="person.subtitle" v-html="person.subtitle"></span>
                </div>

            </button>
        </SmoothLoader>
    </div>
</section>

<teleport to="body">
    <aside v-if="appState != 'idle' && activePerson" :class="appState" class="person-popup bg-primary-800 fixed z-50 left-0 top-0 w-full h-full flex items-center justify-center p-4">
        <div class="popup-backdrop absolute left-0 top-0 w-full h-full pointer-events-none" aria-hidden="true"></div>
        <div class="popup-body relative z-10 grid h-full ht:h-auto mx-auto">
            
            <div class="headshot">
                <img v-if="activePerson.photo" :src="activePerson.photo.src" class="rounded-full">
            </div>

            <div class="info">
                <header class="flex flex-wrap mb-4">
                    <h2 v-html="activePerson.name" class="text-3xl w-full vt:text-4xl text-gray-500 font-headline font-bold leading-none mb-2"></h2>
                    
                    <div v-if="activePerson.linkedin_url" class="pr-2">
                        <a class="text-white transition-colors hover:text-secondary-500 focus:text-secondary-500 text-4xl inline-block mr-4" :href="activePerson.linkedin_url" target="_blank">
                        <i class="fab fa-linkedin" aria-hidden="true"></i>
                        <span class="sr-only">View {{ activePerson.name }} on LinkedIn</span>
                    </a>
                    </div>
                    <div class="flex-1">
                        <h3 v-if="activePerson.job_title" v-html="activePerson.job_title" class="title block text-sm font-headline font-bold uppercase text-primary-400 transition-colors mt-2"></h3>
                        <span v-if="activePerson.subtitle" v-html="activePerson.subtitle" class="block text-gray-400 text-xs uppercase font-headline font-bold"></span>
                    </div>
                    
                </header>

                <div class="bio-container">
                    <div class="bio prose text-white text-sm" v-html="activePerson.bio"></div>
                </div>
                
            </div>

            <div v-if="people.length > 1" class="controls flex justify-end">
                <button @click="prev" class="h-10 w-10 rounded-none appearance-none flex items-center justify-center hover:bg-primary-600 focus:bg-primary-600 transition-colors">
                    <i class="fas fa-chevron-left text-white"></i>
                    <span class="sr-only">Previous Person</span>
                </button>
                <button @click="next" class="h-10 w-10 rounded-none appearance-none flex items-center justify-center hover:bg-primary-600 focus:bg-primary-600 transition-colors">
                    <i class="fas fa-chevron-right text-white"></i>
                    <span class="sr-only">Next Person</span>
                </button>
            </div>

        </div>
        <button @click="close" class="closer text-white font-headline font-bold absolute transition-colors z-50">
            Back to Site
        </button>
    </aside>
</teleport>

</template>

<script>
import { ref, computed, onMounted, nextTick } from 'vue';
const $ = window.jQuery;
export default {
    props: ['data'],
    setup(props) {

        const appState = ref('idle');
        const activeIndex = ref(null);
        const activePerson = computed(() => {
            if (activeIndex.value === null) {
                return null;
            }
            return props.data.people[activeIndex.value];
        });

        const openPerson = async (i) => {
            activeIndex.value = i;
            appState.value = 'popping-in';
            await Promise.all([nextTick(), window.wait(50)]);
            appState.value = 'popped';
            $('html, body').addClass('overflow-y-hidden');
        };

        const close = async () => {
            appState.value = 'popping-out';
            await window.wait(350);
            activeIndex.value = null;
            appState.value = 'idle';
            $('html, body').removeClass('overflow-y-hidden');
        };

        const switchTo = async (i) => {
            appState.value = 'switching-out';
            await window.wait(350);
            activeIndex.value = i;
            await Promise.all([nextTick(), window.wait(50)]);
            appState.value = 'switching-in';
            await window.wait(350);
            appState.value = 'popped';
        };

        const next = () => {
            let nextIndex = activeIndex.value + 1;
            if (nextIndex >= props.data.people.length) {
                nextIndex = 0;
            }
            switchTo(nextIndex);
        };

        onMounted(() => {

            if (!window.location.hash) {
                return;
            }

            let slug = window.location.hash.slice(1);
            let index = props.data.people.findIndex(person => person.slug == slug);
            if (index == -1) {
                return;
            }

            window.wait(200).then(() => {
                switchTo(index);
            });

        });

        const prev = () => {
            let nextIndex = activeIndex.value - 1;
            if (nextIndex < 0) {
                nextIndex = props.data.people.length - 1;
            }
            switchTo(nextIndex);
        };

        return {
            activeIndex,
            activePerson,
            appState,
            close,
            ...props.data,
            openPerson,
            next,
            prev
        }
    }
}
</script>